// Redux
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

// Types
import { UsersUserProfileLanguageChoices } from "@/api/graphql/types"

// Env
import { DEFAULT_LANG } from "@/lib/env"

export interface UserPreferencesState {
	lang: UsersUserProfileLanguageChoices
	showInvestmentBanner: boolean
	ratingModalDismissedUntil: string | null
}

export const initialState: UserPreferencesState = {
	lang: DEFAULT_LANG,
	showInvestmentBanner: true,
	ratingModalDismissedUntil: null,
}

const userPreferencesSlice = createSlice({
	name: "preferences",
	initialState,
	reducers: {
		setLang: (
			state,
			action: PayloadAction<UsersUserProfileLanguageChoices>,
		) => {
			state.lang = action.payload
		},
		setShowInvestmentBanner: (state, action: PayloadAction<boolean>) => {
			state.showInvestmentBanner = action.payload
		},
		setRatingModalDismissedUntil: (
			state,
			action: PayloadAction<string | null>,
		) => {
			state.ratingModalDismissedUntil = action.payload
		},
	},
})

// Action creators are generated for each case reducer function
export const {
	setLang,
	setShowInvestmentBanner,
	setRatingModalDismissedUntil,
} = userPreferencesSlice.actions

export default userPreferencesSlice.reducer
